<template>
  <div>
    <div class="pt-0 pb-4 bg-white">
      <Icons :icons="course.icons" font-size="text-6xl" />
      <Tabs
        v-if="list.length > 1"
        ref="tabsComponent"
        class="mb-8"
        :tab-list="transformTabs"
        @emit-tab="scrollBlockEmit"
      />
      <markdown id="summary" :content="course.content" class="mb-8" />
      <div v-if="course.program_file" class="bg-orange-pastel p-4 mb-4 rounded-lg">
        <p class="font-ubuntu font-bold mb-4 mt-6 lg:mt-0">
          {{ t('formation.courses.material.downloadPdf') }}
        </p>
        <div class="flex items-center mb-4">
          <icon name="pt-document-pdf" class="text-xl text-red mr-3 font-bold" />
          <a
            class="text-sm lg:text-base underline text-left font-semibold text-gray-dark"
            :href="course.program_file.file.url"
          >
            {{ course.program_file.title }}
          </a>
        </div>
      </div>
    </div>
    <material-banner
      v-if="!checkOldMaterial && !checkNewMaterial && checkMaterial"
      class="my-8"
      icon="pt-folder-lock"
      :title="t('formation.courses.material.notAvaible')"
      :text="t('formation.courses.material.textNotAvaible')"
    />
    <DownloadMaterial
      v-if="showMaterial && checkOldMaterial"
      :resources="course.resources"
      :show-always="course.event_features.show_material_always"
      class="my-4"
    />
    <Collapsible
      v-if="course.event_features"
      id="blockSection"
      :list="list"
      :enrolled="enrolled"
      :exist-material="checkNewMaterial || checkOldMaterial"
      :check-new-material="checkNewMaterial"
      :material="course.event_features.show_material_always"
      :show-material="showMaterial"
      :event-format="course.event_features.event_format"
    />
  </div>
</template>

<script>
import { addTime, dateToday } from '~/utils/helpers/date';
import MaterialBanner from '@/components/Banners/PrivateContent/Material';
import DownloadMaterial from '@/components/DownloadMaterial';
import Icons from '~/components/Widgets/IconsSection';
import { useElementVisibility } from '@vueuse/core';
import Collapsible from '@/components/Collapsible';
import { TYPE_COURSE_ONLINE } from '@/utils/enums';

export default {
  name: 'Detail',
  components: {
    Icons,
    Collapsible,
    MaterialBanner,
    DownloadMaterial
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    enrolled: {
      type: Boolean,
      default: false
    },
    course: {
      type: Object,
      default: () => ({})
    },
    currentTab: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const { typeCourse, scrollBlock, scrollBlockDetailEvents } = useEventsEntities();
    const { t } = useI18n();
    const store = useStore();
    const tabsComponent = useTemplateRef('tabsComponent');
    const headerTabsComponentVisible = useElementVisibility(tabsComponent);
    const scrollBlockEmit = tab => {
      scrollBlock({ scroll: tab.data.scroll, tab: tab.data.tab });
      scrollBlockDetailEvents(tab.data);
      store.dispatch('tools/setTabSectionIndex', tab.index - 1);
    };

    const transformTabs = computed(() => {
      const tabs = [{ name: 'Resumen', scroll: 'summary', id: 'summary-tab' }];
      if (typeCourse === TYPE_COURSE_ONLINE && props.course?.objectives?.length) {
        tabs.push({
          name: 'Objetivos',
          scroll: 'objectives',
          id: 'objectives-tab'
        });
      }
      if (props.typeCourse !== 'online') {
        props.list?.forEach((_, index) => {
          tabs.push({
            name: `${t('formation.courses.inscription.session')} ${index + 1}`,
            scroll: 'blockSection',
            tab: index
          });
        });
      } else {
        props.list?.forEach((_, index) => {
          tabs.push({
            name: `${t('formation.courses.block')} ${index + 1}`,
            scroll: typeCourse === TYPE_COURSE_ONLINE ? 'blockSectionOnline' : 'blockSection',
            id: `block-${index}-tab`,
            tab: index
          });
        });
      }
      return tabs;
    });

    watch(headerTabsComponentVisible, val => {
      if (val) store.dispatch('tools/setTabSectionIndex', 0);
    });
    return {
      t,
      typeCourse,
      transformTabs,
      scrollBlockEmit
    };
  },
  data: () => ({
    expiredDate: null
  }),
  computed: {
    expiredWebinar() {
      const minutes =
        this.course.list_of_sessions[this.course.list_of_sessions.length - 1].total_duration;
      return dateToday() < addTime(this.expiredDate, minutes, 'minutes');
    },
    showMaterial() {
      return (
        this.course.event_features?.event_format === 'webinar' ||
        this.course.event_features?.show_material_always
      );
    },
    checkOldMaterial() {
      return !!(this.course?.resources?.videos?.length || this.course?.resources?.files?.length);
    },
    checkNewMaterial() {
      return this.list.some(session =>
        session.lectures.some(presentation => presentation.file || presentation.start_video_at)
      );
    },
    checkMaterial() {
      return this.course.event_features?.will_have_material;
    }
  },
  created() {
    this.expiredDate = new Date(
      this.course.external_form_integrations?.registration_datetime_limit
    );
  }
};
</script>
